function TikTokSVG() {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6102 4.00888C12.622 3.30628 11.9085 2.1826 11.6861 0.872571C11.638 0.589394 11.6116 0.298203 11.6116 0H8.45722L8.45201 13.7801C8.39901 15.3232 7.23399 16.5618 5.80551 16.5618C5.36162 16.5618 4.94346 16.4409 4.57554 16.2295C3.73157 15.7453 3.15411 14.7809 3.15411 13.6713C3.15411 12.0774 4.34364 10.7807 5.80551 10.7807C6.07846 10.7807 6.34008 10.8298 6.58791 10.9143V7.40399C6.3315 7.36593 6.07111 7.34222 5.80551 7.34222C2.60453 7.34255 0 10.1817 0 13.6713C0 15.8125 0.981524 17.7072 2.47862 18.8529C3.42155 19.5746 4.5688 20 5.80582 20C9.0071 20 11.6116 17.1609 11.6116 13.6713V6.6837C12.8486 7.65177 14.3644 8.22213 16 8.22213V4.78361C15.119 4.78361 14.2983 4.4981 13.6102 4.00888Z"
        fill="#E56A17"
      />
    </svg>
  );
}

export { TikTokSVG };
